import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";

export default function CategoryGrid() {
  return (
    <section className="border-b border-background-200 bg-background-100 px-4 py-12 md:px-6 md:py-14 lg:px-8">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">按栏目找重点</h2>
          <p className="mt-2 text-sm text-foreground-600">
            同一件事，你可以只看它处在哪个阶段：还在烧、在争、在辟谣，还是在看风向。
          </p>
        </div>
        <Link
          to="/category/reyi"
          className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          浏览全部事件
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((item) => (
          <Link
            key={item.slug}
            to={`/category/${item.slug}`}
            className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative h-32 w-full overflow-hidden bg-background-200">
              <img
                src={item.cover}
                alt={`${item.name}栏目配图`}
                title={`${item.name} - 蝌蚪爆料栏目`}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-4">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950">{item.name}</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <span className="mt-auto inline-flex items-center gap-1 pt-4 text-xs font-medium text-primary-700">
                进入栏目
                <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}